import React, { useState, useEffect } from 'react';
import { Form, Button, Modal, Col, Row, Tab, Tabs, Alert, Accordion } from 'react-bootstrap';
import InbursaUsersCrudService from '../../../services/InbursaUsersCrudService';

import Spinner from '../../utils/Spinner';

export default function ModalMultiInbursaUsers({ show, handleClose, dataItem, setRenderRows }) {

  const conditionView = (dataItem.typeView === 'View' || dataItem.typeView === 'Delete') ? true : false;
 
  const [successSend, setSuccessend] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [suscriptionCode, setSuscriptionCode] = useState('');
  const [suscriptionPeriod, setSuscriptionPeriod] = useState('');
  const [suscriptionExpires, setSuscriptionExpires] = useState(null);
  const [enableChangePlan, setEnableChangePlan] = useState(true);

  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time)
    )
  }

  const handleSubmit = async (value) => {
    setIsLoading(true);
    let dataUpdateUser = { cashierNumber: -1, enabled: value };

    dataItem.codeItem.forEach(codeItem => {  
      InbursaUsersCrudService.updateUser(dataUpdateUser, codeItem).then(res => {
        //console.log(res);
        console.log('User Code: '+codeItem+' Actualizado');
      });
    });

    setSuccessend('success');
    sleep(1500).then(() => {
      handleClose();
      setIsLoading(false);
      window.location.href = '/reports/inbursausers';
    })

  };

  let addSubmitButton = "";
  if (!conditionView) {
    addSubmitButton = (
          <><Button variant="success" onClick={() => handleSubmit(true)} size="sm">Enabled</Button> { ' ' } { ' ' }
            <Button variant="danger" onClick={() => handleSubmit(false)} size="sm">Disabled</Button>{ ' ' } { ' ' }</>);
  }

  const setCloseButton = (<>
    {addSubmitButton}
    <Button variant="secondary" size="sm" onClick={handleClose}> Close </Button>
  </>);

  return (
    <>
      <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title> {dataItem.typeView} {dataItem.nameView} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-3">

            <div>
              {dataItem.codeItem.map((itemRole) => {
                return (

                  <Alert key={itemRole} variant='info'>
                    Enable or Disable User Id <b>{itemRole}</b>.
                  </Alert>

                )
              })}
            </div>

          </Row>
          <hr></hr>
          {setCloseButton}

          {(successSend == 'danger') ?
            (<Alert key='danger' variant='danger'> Users no actualizado!</Alert>)
            : (successSend == 'success') ?
              (<Alert key='success' variant='success'> Users Actualizado! </Alert>) : ""
          }
        </Modal.Body>
      </Modal>
    </>
  );
}